import type { App } from "vue";
import {
  configure,
  defineRule,
  Field,
  FieldArray,
  Form as VeeForm,
} from "vee-validate";
import * as availableRules from "@vee-validate/rules";
import { localize, setLocale } from "@vee-validate/i18n";
import ja from "@/config/validate/ja.json";
import * as custom_rules from "@/validators/index";

export default {
  install: (app: App<Element>) => {
    app.component("ValidationObserver", VeeForm);
    app.component("ValidationProvider", Field);
    app.component("ValidationArray", FieldArray);
    Object.keys(availableRules)
      .filter((rule) => rule !== "all")
      .forEach((rule) => {
        defineRule(rule, (availableRules as any)[rule]);
      });

    for (const [rule, validation] of Object.entries(custom_rules)) {
      // TODO Vue3 どうしてもいけないので、anyで型チェックをスキップする
      // Typescriptのバグかも
      defineRule<any, any>(rule, validation.validate);
    }
    // エラーメッセージの設定
    configure({
      generateMessage: localize({
        ja,
      }),
    });
    setLocale("ja");
  },
};
